<template>
    <v-app>
        <section id="header">
            <v-navigation-drawer v-model="drawer" app temporary disable-route-watcher disable-resize-watcher>
                <div class="pa-6 font-weight-bold">
                    <div @click.stop="drawer = !drawer"><router-link class="mb-4" :to="{ name: 'Home'}">Home</router-link></div>
                    <v-divider class="my-4"></v-divider>
                    <div class="mb-4" v-for="(value, index) in $store.state.category" v-bind:key="'MenuCategory'+index" @click.stop="drawer = !drawer"><router-link class="mb-4 d-block" :to="{ name: 'Category', params: { id: value.id }}">{{value.name}}</router-link></div>
                    <v-divider class="my-4"></v-divider>
                    <div class="mb-4" v-for="(value, index) in menu" v-bind:key="'MenuOther'+index" @click.stop="drawer = !drawer"><router-link class="mr-8" :to="{ name: value.name}">{{value.label}}</router-link></div>
                </div>
            </v-navigation-drawer>
            <v-app-bar flat>
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="appbar d-flex d-md-none"></v-app-bar-nav-icon>
                <v-toolbar-title class="pl-0">
                    <router-link :to="{ name: 'Home'}">
                        <v-img :src="require('@/assets/images/logo.png')" contain height="40" position="left center" class="d-none d-md-flex logo"></v-img>
                        <v-img :src="require('@/assets/images/logo.png')" contain height="40" position="center center" class="d-block d-md-none logo"></v-img>
                    </router-link>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="d-none d-lg-flex d-xl-flex text-uppercase">
                    <router-link class="mr-8" :to="{ name: 'Home'}">Home</router-link>
                    <router-link v-for="(value, index) in menu" v-bind:key="'MenuOther2'+index" class="mr-8" :to="{ name: value.name}">{{value.label}}</router-link>
                </div>
            </v-app-bar>
        </section>
        <v-divider></v-divider>
        <v-main>
            <v-scroll-x-transition :hide-on-leave="true">
                <router-view/>
            </v-scroll-x-transition>
        </v-main>
    </v-app>
</template>
<script>
    export default {
        name: 'App',
        data: () => ({
            drawer: false,
            menu: [
                {
                    name: 'Promo',
                    label: 'Promo'
                },
                {
                    name: 'Contact Us',
                    label: 'Contact Us'
                }
            ]
        }),
        mounted() {
            if(this.$store.state.category.length === 0) {
                this.$store.dispatch('requestAPI', {
                    name: 'category/all',
                    params: {}
                }).then(async response => {
                    this.$store.state.category = response.data.result.data;
                });
            }
        },
    }
</script>